import 'babel-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client'; // Updated import for React 18
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './assets/bootstrap.less';
import GlobalStyle from './GlobalStyle';
import App from './components/App';

const store = configureStore();

//preview link was changed as part of "Domains approval" feature, support preview detection for clients with url without "neb-context" query param. EEQ-73077 
window.MDIGITAL = {
  ...window.MDIGITAL, 
  nebContext: 'preview',
};

// React 18 compatible rendering
const container = document.getElementById('root');
const root = createRoot(container); // Use createRoot for React 18
root.render(
  <Provider store={store}>
    <GlobalStyle />
    <App />
  </Provider>
);
